module.exports = __webpack_public_path__ + "img/unidades-ufmg.eac92293.png";